import { atom } from 'jotai';

import { KPIComparison } from '../types/kpi-comparison';

export const kpiComparisonState = atom<KPIComparison>(KPIComparison.NONE);
